import { useEffect, useState } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../firebase/config";

export default function AdminMilestones() {

  const [items, setItems] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  // ================= LOAD =================
  useEffect(() => {
    const fetchData = async () => {
      const snap = await getDoc(doc(db, "siteContent", "milestones"));
      if (snap.exists()) {
        setItems(snap.data().items || []);
      }
    };
    fetchData();
  }, []);

  // ================= CHANGE =================
  const handleChange = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

  // ================= ADD =================
  const addItem = () => {
    setItems([...items, { year: "", title: "", desc: "" }]);
    setActiveIndex(items.length); // auto open new
  };

  // ================= DELETE =================
  const removeItem = (index) => {
    const updated = items.filter((_, i) => i !== index);
    setItems(updated);
    setActiveIndex(null);
  };

  // ================= SAVE =================
  const save = async () => {
    await setDoc(doc(db, "siteContent", "milestones"), {
      items: items
    });
    alert("Saved ✅");
  };

  return (
    <div className="admin-section milestone-admin">

      <h2>Milestones</h2>

      {/* SCROLLABLE AREA */}
      <div className="milestone-list">

        {items.map((item, index) => (
          <div className="milestone-card-admin" key={index}>

            {/* HEADER (CLICKABLE) */}
            <div
              className="milestone-header"
              onClick={() =>
                setActiveIndex(activeIndex === index ? null : index)
              }
            >
              <span>{item.year || "New Year"}</span>
              <h4>{item.title || "Untitled Milestone"}</h4>
            </div>

            {/* BODY (COLLAPSIBLE) */}
            {activeIndex === index && (
              <div className="milestone-body">

                <input
                  placeholder="Year"
                  value={item.year}
                  onChange={(e) =>
                    handleChange(index, "year", e.target.value)
                  }
                />

                <input
                  placeholder="Title"
                  value={item.title}
                  onChange={(e) =>
                    handleChange(index, "title", e.target.value)
                  }
                />

                <textarea
                  placeholder="Description"
                  value={item.desc}
                  onChange={(e) =>
                    handleChange(index, "desc", e.target.value)
                  }
                />

                <button
                  className="delete-btn"
                  onClick={() => removeItem(index)}
                >
                  Delete
                </button>

              </div>
            )}

          </div>
        ))}

      </div>

      {/* ACTIONS */}
      <div className="milestone-actions">
        <button className="add-btn" onClick={addItem}>
          + Add Milestone
        </button>

        <button className="save-btn" onClick={save}>
          Save Changes
        </button>
      </div>

    </div>
  );
}